module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-main"
  }, [_c('div', {
    staticClass: "sign-control"
  }, [(!_vm.base64) ? _c('div', {
    staticClass: "sign-btn",
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("开始签名")]) : _vm._e(), _vm._v(" "), (_vm.base64) ? [_c('div', {
    staticClass: "sign-preview",
    on: {
      "click": function($event) {
        _vm.showPreview = true
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.base64,
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-icon1460188478041",
    on: {
      "click": _vm.clearSign
    }
  })] : _vm._e()], 2), _vm._v(" "), (_vm.showModal) ? _c('div', {
    staticClass: "signModal"
  }, [_c('div', {
    staticClass: "signModal-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "signModal-container"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("\n        电子签名板\n        "), _c('span', {
    staticClass: "iconfont icon-cuowu",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  })]), _vm._v(" "), _c('sign-canvas', {
    ref: "SignCanvas",
    staticClass: "sign-canvas",
    attrs: {
      "options": _vm.options
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sign-btns"
  }, [_c('span', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.canvasClear()
      }
    }
  }, [_vm._v("清空")]), _vm._v(" "), _c('span', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.saveSignPicture()
      }
    }
  }, [_vm._v("保存")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showPreview) ? _c('div', {
    staticClass: "signModal"
  }, [_c('div', {
    staticClass: "signModal-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "signModal-container"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("\n        预览\n        "), _c('span', {
    staticClass: "iconfont icon-cuowu",
    on: {
      "click": function($event) {
        _vm.showPreview = false
      }
    }
  })]), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin": "15px 0",
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": _vm.base64,
      "alt": ""
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-275de3b5","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/fangTXQ/fangTXQ-comp/signModal.vue
// module id = 1752
// module chunks = 107